import React, { useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faImage, faIndianRupeeSign } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { add_fund_request,msgPromtsuccess } from "../../features/userSlice";

const AddFundManual = () => {
    const [amount, setAmount] = useState("");
    const [utr, setUtr] = useState("");
    const dispatch = useDispatch();
    const { Info } = useSelector((state) => state.users);
    const [image, setImage] = useState(null);

    const payeeAddress = Info?.UPI_ADMIN;
    const handleCopy = () => {
      navigator.clipboard.writeText(payeeAddress);
      dispatch(msgPromtsuccess({msg:`UPI copied to clipboard!`,error:false}));
     // alert(`${text} copied to clipboard!`);
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file && file.type.startsWith("image/")) {
          setImage(file);
        } else {
          dispatch(msgPromtsuccess({msg:"Please select a valid image file.",error:true}));
        }
      };
    
  
    const handleSubmit = (e) => {
      e.preventDefault();
      // if (!image) {
      //   dispatch(msgPromtsuccess({msg:"Please select an image first.",error:true}));
      //   return;
      // }
      if (!amount) {
        dispatch(msgPromtsuccess({msg:"Please Enter Amount first.",error:true}));
        return;
      }
      if (!utr) {
        dispatch(msgPromtsuccess({msg:"Please Enter UTR first.",error:true}));
        return;
      }
      let data = new FormData();
      data.append('phone_number',Info?.phone_number);
      data.append('amount', amount);
      data.append('UTR_NUM',utr );
      data.append('image',image );
      dispatch(add_fund_request(data));
    };
    
    const fileInputRef = useRef(null);

  // Function to trigger the file input click
  const handleDivClick = () => {
    // Trigger the file input click when the div is clicked
    fileInputRef.current.click();
  };

return (
        <div className="all_bids" style={{padding:'4%'}}>
            <div style={{textAlign:'left',padding:'14px',color:'gray'}}>
            <h4>Upload the payment</h4>
            <h4>screenhot (with UTR number) and</h4>
            <h4>submit</h4>
            </div><br/>
            <div className="input-group">
                <i><FontAwesomeIcon icon={faIndianRupeeSign} color="gray" size="1x" padding='3%' /></i>
                <input className="input_lable_deep" type="number" value={amount} onChange={(e)=>setAmount(e.target.value)} placeholder="" />
            </div><br/>
             {parseInt(amount) ? <div style={{color:'red'}}>  {payeeAddress}   <span style={{color:'blue'}} onClick={handleCopy}>Copy</span></div>:''}
             <br/>
            <div className="input-group">
                <input className="input_lable_deep" type="number" value={utr} onChange={(e)=>setUtr(e.target.value)} placeholder="Enter UTR Number" />
            </div>
            

            <h4 style={{textAlign:'center',color:'red'}}> OR </h4><br/>

            <div className="image_div" onClick={handleDivClick}>
                <FontAwesomeIcon className="imageIcon" icon={faImage} size="6x" color="grey"/>
            </div>
            <input
                type="file"
                ref={fileInputRef} 
                style={{ display: 'none' }}
                onChange={handleImageChange}
                accept="image/*" 
        />
           <br/>
            <button style={{marginLeft:'9%',width:'80%'}} onClick={handleSubmit} className="continue-button">SUBMIT</button>
            <br/><br/><br/>
        </div>
    );
};

export default AddFundManual;
